/* @flow */

export const signupCodeFieldMaxLength = 100;
export const signupEmailFieldMaxLength = 100;
